import React from "react";
import ConnectingButton from "./ConnectingButton";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

const ConnectingButtons = ({ setIsRoomHostAction, user, onLoginClick }) => {
  let history = useHistory();

  const pushToJoinRoomPage = () => {
    setIsRoomHostAction(false);
    history.push("/join-room?host=false");
  };

  const pushToJoinRoomPageAsHost = () => {
    // Check if user is logged in before allowing host
    if (!user) {
      onLoginClick();
      return;
    }
    setIsRoomHostAction(true);
    history.push("/join-room?host=true");
  };

  return (
    <div className="connecting_buttons_container">
      <ConnectingButton
        buttonText="Join a meeting"
        onClickHandler={pushToJoinRoomPage}
      />
      <ConnectingButton
        createRoomButton
        buttonText="Host a meeting"
        onClickHandler={pushToJoinRoomPageAsHost}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps, null)(ConnectingButtons);
